<template>
    <v-container>
        <v-toolbar-title style="font-size: 24px; font-weight: 500; color:#8e79cc"><b>Dashboard</b></v-toolbar-title>
            <v-row class="custom_dash" justify="space-around">
                <v-col cols="12" md="4">
                    <v-card class="bg-danger">
                        <v-row>
                            <v-card-text class="mx-4"  style="color:white;">
                                Courses
                            </v-card-text> 
                        </v-row>

                        <v-row dense>
                            <v-col cols="3"  class="mx-4">
                                <span 
                                    style="font-size:38px;color:white;"
                                    > <b> {{totalCourses}}</b>
                                </span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="4" class="text-right">
                                <v-icon style="font-size:56px;color:white"  class="pr-3">mdi-school</v-icon>
                            </v-col>
                        </v-row>
                    </v-card> 
                </v-col> 

                <v-col cols="12" md="4">
                    <v-card class="bg-info">
                        <v-row>
                            <v-card-text class="mx-4" style="color:white;">
                                Lessons
                            </v-card-text> 
                        </v-row>

                        <v-row dense>
                            <v-col cols="3" class="mx-4" >
                                <span 
                                    style="font-size:38px;color:white;"
                                    > <b> {{totalLessons}}</b></span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="4" class="text-right">
                                <v-icon style="font-size:56px;color:white;" class="pr-3">mdi-book-open-variant</v-icon>
                            </v-col>
                        </v-row>
                    </v-card> 
                </v-col> 

                <v-col cols="12" md="4">
                    <v-card class="bg-warning">
                        <v-row>
                            <v-card-text class="mx-4"  style="color:white;">
                                Questions
                            </v-card-text> 
                        </v-row>
                        <v-row dense>
                            <v-col cols="3" class="mx-4">
                                <span 
                                    style="font-size:38px;color:white;"> <b> {{totalQuestions}}</b></span>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="4" class="text-right">
                                    <v-icon style="font-size:56px;color:white;" class="pr-3">mdi-file-question</v-icon>
                                </v-col>
                        </v-row>
                    </v-card> 
                </v-col> 
            </v-row>
        </v-container>
</template>

<script>
import Course from "../../models/Course.js";
import Lesson from "../../models/Lesson.js";
import TypeOneQuestion from "../../models/TypeOneQuestion.js";
export default {

        beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                    {
                        vm.$router.push("/");
                    }
                }, 0);
            });
        },

    name: "Dashboard",
    data() {
        return {
            totalCourses:undefined,
            totalLessons:undefined,
            totalQuestions:undefined,
            }
    },

    methods: {
        getDashboardInfo() {
            Course.getCourseCount(this.auth.token)
                .then(res => { 
                    this.totalCourses = res.data.courseCount;          
                }).catch(err => console.error(err.response.data));

            Lesson.getLessonCount(this.auth.token)
                .then(res => {
                    this.totalLessons = res.data.lessonCount;           
                }).catch(err => console.error(err.response.data)); 
                
            TypeOneQuestion.getQuestionCount(this.auth.token)
                .then(res => {
                    this.totalQuestions = res.data.questionCount;           
                }).catch(err => console.error(err.response.data)); 
            }
    },
    
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    mounted() {
           this.getDashboardInfo();    
    }
}

</script>

<style scoped>
.custom_dash >>> .v-card__text{
    padding:16px 16px 5px;
    font-weight:600!important;
}
.bg-danger {
    background-color: #d9534f!important;
}
.bg-info {
    background-color: #5bc0de!important;
}
.bg-warning {
    background-color: #f0ad4e!important;
}
</style>



